import React, { FC } from 'react';

import parse from 'html-react-parser';

import { QuizColorsMode } from '~/blocks/TestCard/TestCard';
import MathJaxBlock from '~/components/MathJaxBlock/MathJaxBlock';
import { StyledSmallTitle } from '~/components/QuestionQuiz/styles';
import { isFormulaRegExp } from '~/hooks/useMathJaxScriptLoader';
import { Maybe } from '~/types';

interface QuestionTitleProps {
  title?: Maybe<string>;
  colorsMode?: QuizColorsMode;
}

const QuestionTitle: FC<QuestionTitleProps> = ({ title, colorsMode }) => {
  if (!title) {
    return null;
  }

  return (
    <StyledSmallTitle
      colorsMode={colorsMode}
      className="card-title"
      data-testid="quizQuestion"
      variant="h2"
    >
      <MathJaxBlock hasFormula={title?.match(isFormulaRegExp)}>{parse(title)}</MathJaxBlock>
    </StyledSmallTitle>
  );
};

export default QuestionTitle;
